import Header from "../components/header";
import React, { useEffect } from "react";

const TermsAndServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  <Header />;
  return (
    <div className="bg-[#F2F1F6] py-8 lg:py-16 lg:px-12 px-4">
      <h1 className="mb-10 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl  text-[#E79014] text-center">
        Terms And Conditions
      </h1>
      <div className="text-gray-700">
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Welcome to <span className="font-bold">Matching Master</span>. These
          Terms and Conditions ("Terms") govern your access to and use of our
          mobile application ("App"). By downloading, installing, or using the
          App, you agree to comply with and be bound by these Terms. If you do
          not agree with these Terms, please do not use the App.
        </p>
      </div>
      <div className="text-gray-700">
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Acceptance of Terms
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          By using the <span className="font-bold">Matching Master</span> App,
          you confirm that you have read, understood, and agree to these Terms
          and Conditions, as well as our Privacy Policy and Security Policy.
          These Terms govern your use of the App, including all associated
          features and services.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Use of the App:
        </h2>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            License
          </h2>
          <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            We grant you a non-exclusive, non-transferable, revocable license to
            use <span className="font-bold">Matching Master</span> for personal,
            non-commercial purposes, subject to compliance with these Terms.
          </p>
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Restrictions
          </h2>
          <p className="mb-2 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            You agree not to:
          </p>
          <ol className="list-disc mb-8 text-lg sm:px-16 xl:px-52">
            <li>
              Modify, copy, distribute, transmit, display, perform, reproduce,
              publish, license, create derivative works from, transfer, or sell
              any content obtained from the App.
            </li>
            <li>
              Use the App for any unlawful purpose or for any purpose prohibited
              by these Terms.
            </li>
            <li>
              Attempt to gain unauthorized access to the App, other user
              accounts, or computer systems related to the App via hacking or
              other means.
            </li>
          </ol>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Features of the App:
        </h2>
        <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We grant you a non-exclusive, non-transferable, revocable license to
          use <span className="font-bold">Matching Master</span> for personal,
          non-commercial purposes, subject to compliance with these Terms.
        </p>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Game Modes
          </h2>
          <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            The App offers several game modes, including:
          </p>
          <ol className="list-disc mb-8 text-lg sm:px-16 xl:px-52">
            <li>
              <span className="font-bold">Quick Game Mode:</span> Choose from
              three difficulty levels: Easy, Medium, and Hard.
            </li>
            <li>
              <span className="font-bold">Stage Mode: </span> Over 30 levels for
              players to complete, with increasing difficulty.
            </li>
            <li>
              <span className="font-bold">2 Players Mode (Coming Soon): </span>
              Play with a friend or another user (coming soon).
            </li>
            <li>
              <span className="font-bold">Shop (Coming Soon): </span> In-app
              purchases for premium levels and features (coming soon).
            </li>
          </ol>
        </div>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Updates and Changes
          </h2>
          <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            The App may undergo periodic updates and new features may be added.
            These updates may require changes to existing functionality or
            introduce new terms. You agree to accept any such updates when using
            the App.
          </p>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          User Account:
        </h2>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Registration
          </h2>
          <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            To access certain features, including progress tracking or in-app
            purchases, you may be required to create an account. You agree to
            provide accurate and complete information during registration and to
            keep it updated.
          </p>
        </div>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Account Security
          </h2>
          <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            You are responsible for maintaining the confidentiality of your
            account credentials, including your password. Any activity conducted
            under your account is your responsibility. If you suspect
            unauthorized access to your account, you must notify us immediately.
          </p>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Privacy
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          Your use of the App is governed by our{" "}
          <span className="font-bold">Privacy Policy</span>, which explains how
          we collect, use, and protect your personal information. By using the
          App, you consent to the data practices described in the Privacy
          Policy.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Intellectual Property:
        </h2>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Ownership
          </h2>
          <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            All content available through the App, including text, images,
            logos, graphics, software, and game assets, is owned by{" "}
            <span className="font-bold">Matching Master</span> or its licensors
            and is protected by copyright, trademark, and other intellectual
            property laws.
          </p>
        </div>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Trademarks
          </h2>
          <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            The trademarks, logos, and service marks displayed within the App
            are owned by <span className="font-bold">Matching Master</span> or
            third parties. You are not permitted to use these marks without
            prior written consent.
          </p>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Disclaimers:
        </h2>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            No Warranty
          </h2>
          <p className="mb-4 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            The App is provided on an "as is" and "as available" basis. We make
            no warranties, expressed or implied, regarding the functionality or
            availability of the App, including but not limited to warranties of
            merchantability or fitness for a particular purpose.
          </p>
        </div>
        <div className="px-8">
          <h2 className="mb-1 text-xl font-bold text-black leading-none md:text-1xl lg:text-2xl text-left sm:px-16 xl:px-48">
            Limitation of Liability
          </h2>
          <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
            We are not liable for any indirect, incidental, special, or
            consequential damages arising from your use or inability to use the
            App. This includes loss of data, profit, or business interruption,
            even if we have been advised of the possibility of such damages.
          </p>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Indemnification
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          You agree to indemnify and hold harmless Matching Master, its
          officers, employees, and affiliates, from any claims, losses,
          liabilities, or expenses (including legal fees) arising from your use
          of the App, violation of these Terms, or infringement of any
          third-party rights.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Termination
        </h2>
        <p className="mb-2 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We may suspend or terminate your access to the App at our discretion,
          without prior notice or liability, if you violate these Terms or
          engage in any activity that harms the App, or other users, or violates
          laws. Upon termination, your right to use the App will cease
          immediately.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Governing Law
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          These Terms are governed by and construed by the laws. You agree to
          submit to the exclusive jurisdiction of the courts in this
          jurisdiction for any disputes arising under these Terms.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Changes to Terms and Conditions
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          We reserve the right to modify these Terms at any time. Any changes
          will be posted on this page with an updated effective date. You are
          encouraged to review these Terms periodically. By continuing to use
          the App after changes are posted, you accept those changes.
        </p>
        <h2 className="mb-4 text-2xl font-bold text-black leading-none md:text-3xl lg:text-4xl text-left sm:px-16 xl:px-48">
          Contact Us
        </h2>
        <p className="mb-8 text-lg font-normal lg:text-xl sm:px-16 xl:px-48">
          If you have any questions about these Terms and Conditions or the
          Matching Master App, please contact us at:
          <a
            href="mailto:info@thekaizenglobal.com"
            className=" text-[#E79014] hover:underline"
          >
            {" "}
            info@thekaizenglobal.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default TermsAndServices;
